import { h, Component } from 'preact';
import PropTypes from 'prop-types';
import Item from './Item';
import ItemPlaceholder from './ItemPlaceholder';
import ButtonLoadMore from './ButtonLoadMore';
import classNames from 'classnames';

class List extends Component {
  componentDidUpdate() {
    window.matchHeight.match('.list-direct-sales-categories__list');
  }

  componentDidMount() {
    window.matchHeight.match('.list-direct-sales-categories__list');
  }

  render() {
    const {
      items,
      part_link,
      loading,
      loadingMore,
      showLoadMore,
      onClickButtonLoadMore,
      customClasses,
    } = this.props;

    return (
      <div className="list-direct-sales-categories__list">
        <div className="row">
          {items.map(item => (
            <div
              className={classNames(
                'list-direct-sales-categories__col',
                customClasses || 'col-sm-6 col-md-4',
              )}
            >
              {loading && !loadingMore ? (
                <ItemPlaceholder />
              ) : (
                <Item
                  slug={item.slug}
                  image={item.item_image && item.item_image.thumb_image}
                  name={item.name}
                  direct_sales_count={item.direct_sales_list_count}
                  summary={item.summary}
                  part_link={part_link}
                />
              )}
            </div>
          ))}
        </div>
        {showLoadMore && (
          <div>
            <hr />
            <ButtonLoadMore
              onClick={onClickButtonLoadMore}
              loading={loadingMore}
            />
          </div>
        )}
      </div>
    );
  }
}

List.defaultProps = {
  items: [],
  showLoadMore: false,
  loading: false,
  loadingMore: false,
  onClickButtonLoadMore() {},
  customClasses: null,
};

List.propTypes = {
  items: PropTypes.array,
  showLoadMore: PropTypes.bool,
  loading: PropTypes.bool,
  part_link: PropTypes.string,
  onClickButtonLoadMore: PropTypes.func,
  customClasses: PropTypes.string,
};

export default List;
